// src/components/place-card/place-card.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment CloseActionFragment on UITertiaryButton {\n    __typename\n    icon {\n      description\n      id\n      token\n    }\n    accessibility\n  }\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment PlaceCardMediaFragment on Image {\n    description\n    url\n  }\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment PlaceCardDetailsFragment on PlaceCardDetails {\n    id\n    title {\n      text\n    }\n    subtitle {\n      text\n    }\n    description {\n      text\n    }\n    media {\n      ...PlaceCardMediaFragment\n    }\n    footerText {\n      text\n    }\n    closeAction {\n      ...CloseActionFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  query PlaceCardDetailsQuery($context: ContextInput!, $placeId: String!, $directionsTo: DirectionsReferenceInput) {\n    placeCardDetails(context: $context, placeId: $placeId, directionsTo: $directionsTo) {\n      ...PlaceCardDetailsFragment\n    }\n  }\n  ", "\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
import React3 from "react";
import { gql as gql3, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { UitkCard, UitkCardContentSection } from "uitk-react-cards";
import { UitkFigureAspectRatioType as UitkFigureAspectRatioType2 } from "uitk-react-images";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkHeading, UitkText } from "uitk-react-text";
// src/components/place-card/__private/__fragments/close-action.tsx
import React from "react";
import { gql } from "@apollo/client";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
import { UitkLayoutPosition } from "uitk-react-layout-position";
var __CloseActionFragment = gql(_templateObject());
var CloseAction = function (param) {
  var closeAction = param.closeAction,
    onClick = param.onClick;
  var _closeAction, _closeAction1;
  if (!((_closeAction = closeAction) === null || _closeAction === void 0 ? void 0 : _closeAction.icon)) {
    return null;
  }
  var icon = (_closeAction1 = closeAction) === null || _closeAction1 === void 0 ? void 0 : _closeAction1.icon;
  var _closeAction_accessibility;
  return /* @__PURE__ */React.createElement(UitkLayoutPosition, {
    type: "absolute",
    position: {
      top: "zero",
      right: "zero"
    }
  }, /* @__PURE__ */React.createElement(UitkTertiaryButton, {
    type: "button",
    "aria-label": (_closeAction_accessibility = closeAction.accessibility) !== null && _closeAction_accessibility !== void 0 ? _closeAction_accessibility : "",
    onClick: onClick
  }, /* @__PURE__ */React.createElement(UitkIcon, {
    name: icon.id
  })));
};
CloseAction.fragment = __CloseActionFragment;
CloseAction.displayName = "CloseAction";
// src/components/place-card/__private/__fragments/place-card-media.tsx
import React2 from "react";
import { gql as gql2 } from "@apollo/client";
import { UitkFigure, UitkImage } from "uitk-react-images";
var __PlaceCardMediaFragment = gql2(_templateObject1());
var PlaceCardMedia = function (props) {
  var data = props.data,
    imageRatio = props.imageRatio;
  switch (data.__typename) {
    case "Image":
      return /* @__PURE__ */React2.createElement(UitkFigure, {
        ratio: imageRatio,
        roundcorner: ["startstart"]
      }, /* @__PURE__ */React2.createElement(UitkImage, {
        placeholderImage: true,
        src: data.url,
        alt: data.description
      }));
    default:
      return null;
  }
};
PlaceCardMedia.fragment = __PlaceCardMediaFragment;
PlaceCardMedia.displayName = "PlaceCardMedia";
// src/components/place-card/analytics/place-card-eg-clickstream-events.tsx
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var EVENT_CATEGORY = "maps";
var buildEvent = function (eventName, eventType, eventVersion) {
  return {
    event_name: eventName,
    event_type: eventType,
    event_version: eventVersion,
    event_category: EVENT_CATEGORY
  };
};
var IMPRESSION = "Impression";
var buildData = function (event, attributes) {
  return _object_spread_props(_object_spread({}, attributes), {
    event: event
  });
};
function usePlaceCardClickstream() {
  var clickstreamTrack = useEgClickstream();
  var track = function (data) {
    if (clickstreamTrack) {
      clickstreamTrack(data);
    }
  };
  var trackMapCardPresented = function (id, type) {
    var event = buildEvent("map_card.presented", IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */);
    var attributes = {
      content_card_list: [{
        id: id,
        card_type: type
      }]
    };
    track(buildData(event, attributes));
  };
  return {
    trackMapCardPresented: trackMapCardPresented
  };
}
// src/components/place-card/place-card.tsx
var __fragment = gql3(_templateObject2(), CloseAction.fragment, PlaceCardMedia.fragment);
var __Query = gql3(_templateObject3(), __fragment);
var PlaceCardSize = /* @__PURE__ */function (PlaceCardSize2) {
  PlaceCardSize2[PlaceCardSize2["STANDARD"] = 0] = "STANDARD";
  PlaceCardSize2[PlaceCardSize2["COMPACT"] = 1] = "COMPACT";
  return PlaceCardSize2;
}(PlaceCardSize || {});
var PlaceCard = function (props) {
  var _queryData, _queryData1, _queryData2, _data, _data1, _data_title, _data2, _data_subtitle, _data_description, _data_footerText;
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    fetchPolicy = props.fetchPolicy,
    propsData = props.data,
    size = props.size,
    imageRatio = props.imageRatio,
    onClose = props.onClose;
  var context = useBexApi().context;
  var variables = React3.useMemo(function () {
    return _object_spread_props(_object_spread({}, inputs), {
      context: context
    });
  }, [inputs, context]);
  var _useQuery = useQuery(__Query, _object_spread({
      variables: variables,
      ssr: !skipSsr,
      notifyOnNetworkStatusChange: true
    }, fetchPolicy ? {
      fetchPolicy: fetchPolicy
    } : {})),
    queryData = _useQuery.data,
    error = _useQuery.error;
  var cleanNulls = function (obj) {
    return !obj ? {} : Object.fromEntries(Object.entries(obj).filter(function (param) {
      var _param = _sliced_to_array(param, 2),
        value = _param[1];
      return value !== null;
    }));
  };
  var nonNullPropsData = cleanNulls(propsData);
  var data = ((_queryData = queryData) === null || _queryData === void 0 ? void 0 : _queryData.placeCardDetails) || ((_queryData1 = queryData) === null || _queryData1 === void 0 ? void 0 : _queryData1.placeCardDetails) === null || error ? _object_spread({}, nonNullPropsData, ((_queryData2 = queryData) === null || _queryData2 === void 0 ? void 0 : _queryData2.placeCardDetails) || {}) : null;
  var ratio = imageRatio || size === 1 /* COMPACT */ ? UitkFigureAspectRatioType2.R3_4 : UitkFigureAspectRatioType2.R4_3;
  var placeCardMinHeight = 63;
  var trackMapCardPresented = usePlaceCardClickstream().trackMapCardPresented;
  var closeAction = (_data = data) === null || _data === void 0 ? void 0 : _data.closeAction;
  React3.useEffect(function () {
    var _data;
    if ((_data = data) === null || _data === void 0 ? void 0 : _data.id) {
      trackMapCardPresented(data.id, "place" /* PLACE */);
    }
  }, [(_data1 = data) === null || _data1 === void 0 ? void 0 : _data1.id]);
  var _data_title_text, _data_description_text, _data_footerText_text;
  return data ? /* @__PURE__ */React3.createElement(UitkCard, null, /* @__PURE__ */React3.createElement("div", {
    "data-testid": "place-card-".concat(data.id)
  }), /* @__PURE__ */React3.createElement(UitkLayoutGrid, {
    alignItems: "start",
    columns: 4,
    style: {
      minHeight: placeCardMinHeight
    }
  }, data.media && data.media.__typename === "Image" ? /* @__PURE__ */React3.createElement(UitkLayoutGridItem, {
    colSpan: 1
  }, /* @__PURE__ */React3.createElement(PlaceCardMedia, {
    imageRatio: ratio,
    data: data.media
  })) : null, /* @__PURE__ */React3.createElement(UitkLayoutGridItem, {
    colSpan: 3
  }, /* @__PURE__ */React3.createElement(UitkLayoutFlex, {
    direction: "column",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React3.createElement(UitkCardContentSection, null, /* @__PURE__ */React3.createElement(UitkSpacing, {
    margin: {
      inlineend: "eight"
    }
  }, /* @__PURE__ */React3.createElement(UitkHeading, null, (_data_title_text = (_data2 = data) === null || _data2 === void 0 ? void 0 : (_data_title = _data2.title) === null || _data_title === void 0 ? void 0 : _data_title.text) !== null && _data_title_text !== void 0 ? _data_title_text : "")), data.subtitle ? /* @__PURE__ */React3.createElement(UitkText, {
    size: 200,
    spacing: "one"
  }, (_data_subtitle = data.subtitle) === null || _data_subtitle === void 0 ? void 0 : _data_subtitle.text) : null, data.description ? /* @__PURE__ */React3.createElement(UitkText, {
    size: 200,
    spacing: "one"
  }, (_data_description_text = (_data_description = data.description) === null || _data_description === void 0 ? void 0 : _data_description.text) !== null && _data_description_text !== void 0 ? _data_description_text : "") : null)), /* @__PURE__ */React3.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */React3.createElement(UitkCardContentSection, null, data.footerText ? /* @__PURE__ */React3.createElement(UitkText, {
    size: 200
  }, (_data_footerText_text = (_data_footerText = data.footerText) === null || _data_footerText === void 0 ? void 0 : _data_footerText.text) !== null && _data_footerText_text !== void 0 ? _data_footerText_text : "") : null))))), closeAction && /* @__PURE__ */React3.createElement(CloseAction, {
    closeAction: closeAction,
    onClick: onClose
  })) : null;
};
PlaceCard.displayName = "PlaceCard";
// src/components/place-card/floating-place-card.tsx
import React4 from "react";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSpacing } from "@egds/react-core/spacing";
var FloatingPlaceCard = function (props) {
  var placeId = props.placeId,
    size = props.size,
    onClose = props.onClose;
  var maxWidth = size === 1 /* COMPACT */ ? 351 : 720;
  return /* @__PURE__ */React4.createElement(EGDSSpacing, {
    margin: {
      inline: "three",
      blockend: "two"
    }
  }, /* @__PURE__ */React4.createElement(EGDSLayoutPosition, {
    type: "absolute",
    tag: "div",
    position: {
      bottom: "one"
    },
    pointerEvents: "none",
    style: {
      width: "calc(100% - 1.5rem)"
    }
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex, {
    justifyContent: "center"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    maxWidth: maxWidth
  }, /* @__PURE__ */React4.createElement("div", {
    style: {
      pointerEvents: "all"
    }
  }, /* @__PURE__ */React4.createElement(PlaceCard, _object_spread_props(_object_spread({}, props), {
    inputs: {
      placeId: placeId
    },
    onClose: onClose
  })))))));
};
export { FloatingPlaceCard, PlaceCard, __fragment as PlaceCardFragment, PlaceCardSize };